export default class Signup {
	constructor(node) {
		this.node = node;
		this.signupFormNode = this.node.querySelector('#form-signup');

		this.settings = window.signupSettings;

		this.addListeners();
	}

	static init() {
		let signupNode = document.querySelector("[data-signup]");

		if (signupNode) {
			return new Signup(signupNode);
		}
	}

	addListeners() {
		let _this = this;

		$(this.signupFormNode).validate({
			getDataToSend: function(form) {
				let isLogged = _this.signupFormNode.querySelector('input[name="isLogged"]').value;

				if (isLogged === "True") {
					return {
						data: {
							nome: "",
							cognome: "",
							email: "",
							nazione: "0",
							password: "",
							profiloPress: _this.signupFormNode.querySelector('select[name="ProfiloPress"]').options[_this.signupFormNode.querySelector('select[name="ProfiloPress"]').selectedIndex].value,
							privacy: true
						}
					};
				} else {
					return {
						data: {
							nome: _this.signupFormNode.querySelector('input[name="Nome"]').value,
							cognome: _this.signupFormNode.querySelector('input[name="Cognome"]').value,
							email: _this.signupFormNode.querySelector('input[name="EMail"]').value,
							nazione: _this.signupFormNode.querySelector('select[name="nazione"]').options[_this.signupFormNode.querySelector('select[name="nazione"]').selectedIndex].value,
							password: _this.signupFormNode.querySelector('input[name="Password"]').value,
							profiloPress: _this.signupFormNode.querySelector('select[name="ProfiloPress"]').options[_this.signupFormNode.querySelector('select[name="ProfiloPress"]').selectedIndex].value,
							privacy: _this.signupFormNode.querySelector("input[name='Privacy']").checked
						}
					};
				}
			},
			rules: {
				Password_conferma: { equalTo: "#password" }
			},
			callbackHandler: function(data, form) {
				_this.signupFormNode.querySelector('.response-text').innerHTML = data.d.HTML;
				if (data.d.Status)
					_this.signupFormNode.querySelector('input[type="submit"]').style.display = 'none';
			}
		});
	}

	validatePassword() {
		let password = document.querySelector('#form-signup input[name="Password"]');
		let passwordConferma = document.querySelector('#form-signup input[name="Password-conferma"]');

		if (password.value !== passwordConferma.value) {
			passwordConferma.setCustomValidity("Le password non coincidono");
		} else {
			passwordConferma.setCustomValidity('');
		}
	}

	submitSignupForm() {
		let _this = this;
		let responseData = {};
		let submittedData = { data: {} };

		this.signupFormNode.classList.add('busy');

		let isLogged = this.signupFormNode.querySelector('input[name="isLogged"]').value;

		if (isLogged === "True") {
			submittedData.data = {
				nome: "",
				cognome: "",
				email: "",
				nazione: "0",
				password: "",
				profiloPress: this.signupFormNode.querySelector('select[name="ProfiloPress"]').options[this.signupFormNode.querySelector('select[name="ProfiloPress"]').selectedIndex].value,
				privacy: true
			};
		} else {
			submittedData.data = {
				nome: this.signupFormNode.querySelector('input[name="Nome"]').value,
				cognome: this.signupFormNode.querySelector('input[name="Cognome"]').value,
				email: this.signupFormNode.querySelector('input[name="EMail"]').value,
				nazione: this.signupFormNode.querySelector('select[name="nazione"]').options[this.signupFormNode.querySelector('select[name="nazione"]').selectedIndex].value,
				password: this.signupFormNode.querySelector('input[name="Password"]').value,
				profiloPress: this.signupFormNode.querySelector('select[name="ProfiloPress"]').options[this.signupFormNode.querySelector('select[name="ProfiloPress"]').selectedIndex].value,
				privacy: this.signupFormNode.querySelector("input[name='Privacy']").checked
			};
		}

		_this.signupFormNode.querySelector('.success-msg').innerHTML = "";
		_this.signupFormNode.querySelector('.error-msg').innerHTML = "";

		$.ajax({
			type: "POST",
			url: this.signupFormNode.getAttribute('action'),
			cache: false,
			contentType: "application/json; charset=utf-8",
			data: JSON.stringify(submittedData),
			dataType: "json",
			success: function(data) {
				responseData = data;

				if (responseData.d.Status === true) {
					_this.signupFormNode.querySelector('.success-msg').innerHTML = responseData.d.HTML;
				} else {
					_this.signupFormNode.querySelector('.error-msg').innerHTML = responseData.d.HTML;

					console.log("response error: ");
					console.log(responseData.d.ErrMessage);
				}
			},
			error: function(data) {
				responseData = data;

				_this.signupFormNode.querySelector('.error-msg').innerHTML = _this.settings.labels.form_error;

				console.log("response error: ");
				console.log(responseData);
			},
			complete: function() {
				// console.log(responseData);

				_this.signupFormNode.classList.remove('busy');
			}
		});
	}
}
